import { browser } from '$app/environment';
import { Cookies, fromDocument } from '$lib/services/helpers/cookies';
import { DateTime } from 'luxon';

const DEVICE_ID_COOKIE_NAME = 'spine.device-info.device-id';

export class DeviceInfo {
    private deviceId: string;
    constructor() {
        if (!browser) {
            throw Error('Only supported in the browser');
        }
        const cookies = new Cookies(fromDocument(document));
        const deviceId = cookies.get(DEVICE_ID_COOKIE_NAME);
        if (!deviceId) {
            this.deviceId = crypto.randomUUID();
        } else {
            this.deviceId = deviceId;
        }
        // Note: push the expiry time forward each time we run the constructor
        cookies.set(
            DEVICE_ID_COOKIE_NAME,
            this.deviceId,
            {
                maxAge: DateTime.now().plus({ days: 400 }).toMillis(),
                path: '/',
                httpOnly: false,
                secure: false,
                sameSite: 'lax'
            },
            true
        );
    }
    getDeviceId = () => this.deviceId;
}
